import { type RefObject, useEffect, useMemo } from "react";
import { type AnimatedScroll, createAnimatedScroll } from "../lib/animated-scroll";

/**
 * One owned scroll animation for one scroll container, for as long as the component is mounted.
 *
 * It takes the ref rather than the element because the container is created by the same render
 * this is called from: there is nothing to hand over on the first pass, and a travel resolves the
 * node when it actually starts. Unmounting stops whatever is in flight, so a tween never writes
 * `scrollTop` on a node React has already thrown away.
 */
export function useAnimatedScroll(scrollerRef: RefObject<HTMLElement | null>): AnimatedScroll {
  const scroll = useMemo(() => createAnimatedScroll(() => scrollerRef.current), [scrollerRef]);
  useEffect(() => () => scroll.stop(), [scroll]);
  return scroll;
}
